module.exports = __webpack_public_path__ + "img/login.0449b81c.svg";